<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <b-alert variant="danger"
                          dismissible
                          :show="showDismissibleAlert"
                          @dismissed="showDismissibleAlert=false">
                    {{errorMsg}}
                  </b-alert>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model = "username" class="form-control" placeholder="Username" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model = "password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" v-on:click="login(username,password)" class="px-4">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <router-link variant="link" class="px-0" :to="{ name: 'forgetpassword'}">Forgot password?</router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Login',
  data: function(){
    return {
      username:"",
      password:"",
      showDismissibleAlert:false,
      errorMsg:""
    }
  },
  methods: {
    async login(username,password){
      if(username,password){
        try{ 
          let loggedIn = await this.strapi.login(username, password);
          if(loggedIn.jwt){
            let currentUser = await this.currentuser();
            let accessallowed = await this.strapi.getEntries('custompermissions',{role:currentUser.role.id});
            this.$store.dispatch('login', {user:currentUser, accessallowed});
            this.$router.push({path:'dashboard'});
          }
        }catch(e){
          this.errorMsg="Username or Password is invalid!";
          this.showDismissibleAlert=true;
        }
      }else{
        this.errorMsg="Username and Password is Required!";
        this.showDismissibleAlert=true;
      }
    }
  }
} 
</script>
